import { render } from "./FireScbaGraph.vue?vue&type=template&id=f6d4ae78&scoped=true"
import script from "./FireScbaGraph.vue?vue&type=script&lang=ts"
export * from "./FireScbaGraph.vue?vue&type=script&lang=ts"

import "./FireScbaGraph.vue?vue&type=style&index=0&id=f6d4ae78&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f6d4ae78"

export default script